const breakpoint = {
  tablet: "768px",
  desktop: "1024px",
};

export default breakpoint;
